import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["testId", "src", "size", "teamId"];
import React from 'react';
import Avatar from '@atlaskit/avatar';
import { N0, N90 } from '@atlaskit/theme/colors';
import { TeamAvatarImage } from './teams-avatar-image';

/*
 * The component accepts src and teamId as input params. Order of preference:
 * If src is provided, use that directly.
 * Else if teamId is provided, use that to generate the static image URL.
 * Else fallback.
 */

export var ICON_BACKGROUND = "var(--ds-icon-inverse, ".concat(N0, ")");
export var ICON_COLOR = "var(--ds-icon-subtle, ".concat(N90, ")");
export default function TeamAvatar(_ref) {
  var testId = _ref.testId,
    src = _ref.src,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'medium' : _ref$size,
    _ref$teamId = _ref.teamId,
    teamId = _ref$teamId === void 0 ? '' : _ref$teamId,
    props = _objectWithoutProperties(_ref, _excluded);
  // Strip ARI in case the teamId was given in that format
  teamId = teamId.replace('ari:cloud:identity::team/', '');
  return /*#__PURE__*/React.createElement(Avatar, _extends({
    appearance: "square"
  }, props, {
    size: size,
    src: src,
    testId: "".concat(testId, "-team-avatar")
  }), /*#__PURE__*/React.createElement(TeamAvatarImage, {
    src: src,
    size: size,
    testId: testId,
    teamId: teamId
  }));
}